import path from './index'
import { axios } from '@/utils/request'

export function login (parameter) {
  return axios({
    url: path.sys + '/loginjwt',
    method: 'post',
    contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
    params: parameter
  })
}
// 用户信息
export function getInfo () {
  return axios({
    url: path.sys + '/token/user',
    headers: { 'reload': false },
    method: 'post'
  })
}
// 用户信息
export function changePhone (data) {
  return axios({
    url: path.sys + '/token/changePhone',
    method: 'post',
    data
  })
}

// 发送短信验证码
export function getSmsCaptcha (parameter) {
  return axios({
    url: path.sys + '/validationcode/sms/create',
    method: 'post',
    params: parameter
  })
}

// 农行登录
export function abChinaLogin (data) {
  return axios({
    headers: { 'reload': false },
    url: path.client + '/abchina/login',
    method: 'POST',
    params: data
  })
}

/**
 * 生成图形验证码
 * @returns {*}
 */
export function validationCodeWithImage () {
  return axios({
    url: path.sys + '/validationcode/image/create',
    method: 'post',
    headers: { 'check': true },
    contentType: 'application/x-www-form-urlencoded;charset=UTF-8'
  })
}
